<div class="lead-note-avatar-holder">
    <app-avatar [user]="note.createdBy"></app-avatar>
</div>
<div class="lead-note-body">
    <div class="lead-note-createdBy">{{ note.createdBy.contact.firstname }} {{ note.createdBy.contact.surname }}</div>
    <div
        class="lead-note-contant"
        [innerHTML]="note.content"></div>
    <div
        *ngIf="note.files.length"
        class="lead-note-files">
        <div
            *ngFor="let file of note.files"
            class="lead-note-file"
            (click)="viewFile(file)">
            <img
                class="lead-note-file-img"
                src="{{ getFilePath(file) }}" />
        </div>
    </div>
</div>
<div class="lead-note-date-holder">
    {{ note.createdAt | date : 'dd.MM.yyyy HH:mm a' }}
</div>

<app-simple-image-viwer [viewImage$]="viewImage$"></app-simple-image-viwer>
